import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {Partner} from '../../models/partner/partner';
import {Observable, Subscriber} from 'rxjs';
import {ApiResponse} from '../../api/api-response';
import {AuthService} from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PartnerService extends AbstractModelService<Partner> {

  constructor(apiClient: ApiClientService, private authService: AuthService) {
    super(apiClient, '/partner', Partner);
  }

  getAdvertisingPlatformImage(partner: Partner): string {
    return '/images/ads/small/' + partner.advertisingPlatform?.identifier + '.webp';
  }

  login(id: number): Observable<any> {
    return new Observable<any>((subscriber: Subscriber<any>): void => {
      this.apiClient.post(this.routePath + '/' + id + '/login').subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  getDownloadUrl(filename: string): string {
    return this.apiClient.getUrl(this.routePath + '/download/' + filename, {token: this.authService.getBearer()});
  }
}
